const API_URL = process.env.REACT_APP_authServiceURL;


const Apis = {
    CreateBeyondBellsQuery: `${API_URL}/beyond/the/bell/save`,
    GetBeyondBellsMediaLink: (data) => `${API_URL}/beyond/the/bell/media/link/enable-list?page=${data?.page}&size=${data?.size}`
};
export { API_URL, Apis };